import React,{useEffect,useRef} from 'react';
import { Select } from 'antd';
import 'antd/dist/antd.css';
import {getSegmentMarketData} from '../services/chartdata'
import {percentOption,fillSeries} from '../utils/chartOptionConfig'

//按需加载
import echarts from 'echarts/lib/echarts'
//必需基础组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markPoint'
//导入矩形图
import 'echarts/lib/chart/bar'　
import 'echarts/lib/chart/line'　





export default function SegmentMakret(props) {
	const { Option } = Select;

	// function handleChange(value) {
	// 	console.log(`selected ${value}`);		
	// 	renderMyChart(value-1);
	// }

	
	const refObj={};
	refObj['轿车']=useRef();
	refObj['SUV']=useRef();
	refObj['MPV']=useRef();
	

	const categories=['轿车','SUV','MPV'];
	// for(let a of categories){
	// 	refObj[str]=useRef();
	// }

	// ['轿车','SUV','MPV'].map((str)=>{
	// 	refObj[str]=useRef();
	// })



    let myChart=null;
    
	function renderMyChart(numType){
		numType=numType||2;
		getSegmentMarketData().then((dt)=>{						
			// jsonData=dt;
			categories.forEach((str,index)=>{
				let datalist=dt[index].dataList;
				datalist=dt.filter((o)=>{
					return o['category']==str;
				});
				// console.log('datalist',datalist)
				datalist=datalist[0].dataList;
				const chart=echarts.getInstanceByDom(refObj[str].current)
				let myChart=null;
				if(chart){
					myChart=chart;
				}else{
					myChart=echarts.init(refObj[str].current);
				}
				myChart.setOption(percentOption);
				let res=datalist.map(obj=>{
					let new_obj={};				
					for(let [k,v] of Object.entries(obj)){
						if(Array.isArray(v)){
							// new_obj[k]=v[numType];
							new_obj[k]=v[numType].toFixed(1);
						}else{
							new_obj[k]=v;
						}
					}
					return new_obj;
				})
                // console.log('res',res)	
                // let series=myChart.getOption().series;
				// series.push({
                //     type: 'bar',
                //     stack:'占比',
                //      label: {
                //             show: true,
                //             fontSize: 10,
                //             formatter: '{@[4]}%'
                //         }
                // });
                // series.push({
                //     type: 'bar',
                //     stack:'占比',
                //      label: {
                //             show: true,
                //             fontSize: 10,
                //             formatter: '{@[5]}%'
                //         }
				// });
				let seriesCount=Object.keys(res[0]).length-1;
                let series=fillSeries(seriesCount);
				myChart.setOption({
                    series:series,
                    legend:{
                        orient:'vertical',
                        left:10,
                        top:150,
                        itemGap:50,
                        data: [{
                            name: 'A00'                           
                        },{
                            name: 'A0'                           
                        },{
                            name: 'A'                           
                        },{
                            name: 'B'                           
                        },{
                            name: 'C'                           
                        }]
                    },
                    grid:{
                        left:80,
                        top:0
                    },
					title:{
						'text':str,
						top:50
					},
					dataset:{
						source:res
					}
				});

			})          
		});
	}
	// 

	useEffect(()=>{
		// console.log("did.....")
		renderMyChart();
		return ()=>{
			// console.log("unmount...");
			myChart && myChart.dispose();
		}
	})
	return (
		<>
		<div>
            {/* ManRank
			<Select defaultValue="2" style={{ width: 100 }} onChange={handleChange}>				
				<Option value="2">批发</Option>				
				<Option value="3">零售</Option>				
			</Select> */}
			<div style={{width: "1100px", height: "600px"}} ref={refObj['轿车']} />						
			<div style={{width: "1100px", height: "600px"}} ref={refObj['MPV']} />			
			<div style={{width: "1100px", height: "600px"}} ref={refObj['SUV']} />			
			{/* <div style={{width: "1100px", height: "400px"}} ref={refObj['占比']} />			 */}
			{/* <div style={{width: "1100px", height: "400px"}} ref={chartRef} /> */}
		</div>

		</>
	);
}
